export const data_tech_steps = [
  {
    title: 'Gear up',
    description: 'Put on your favorite XR headset.',
  },
  {
    title: 'Investigate',
    description: 'Explore the virtual model and its surroundings using intuitive controls.',
  },
  {
    title: 'Customize',
    description: 'Adjust the model’s configurations for the optimal outcome.',
  },
  {
    title: 'Collaborate ',
    description: 'Work in real-time with others to finalize your design.',
  },
  {
    title: 'Experience ',
    description: 'Watch your machine interact with the real and virtual environment.',
  },
];
